import { render, staticRenderFns } from "./ToReceivePayments.vue?vue&type=template&id=f38d91fc"
import script from "./ToReceivePayments.vue?vue&type=script&lang=js"
export * from "./ToReceivePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports